// 注释掉原来的 Ollama 相关代码

import { generateResponse, checkOllamaService } from './ollamaService'

/**
 * 测试API连接
 * @returns {Promise<Object>} 测试结果
 */
export async function sendTestMessage() {
  try {
    // 构建一个简单的测试消息
    const testMessage = [{
      role: 'user',
      content: '这是一个API连接测试，请简短回复。'
    }]

    // 使用现有的sendChatMessage函数测试API连接
    const response = await sendChatMessage(testMessage)

    return {
      success: true,
      message: '成功连接到API服务',
      response
    }
  } catch (error) {
    console.error('API连接测试失败:', error)
    throw error
  }
}

/**
 * 发送聊天消息到本地Ollama模型
 * @param {Array} messages 聊天历史
 * @returns {Promise<string>} AI回复内容
 */

export async function sendChatMessage(messages) {
  try {
    // 先检查Ollama服务是否可用
    const serviceAvailable = await checkOllamaService()
    if (!serviceAvailable) {
      throw new Error('Ollama服务不可用，请确认服务已启动 http://localhost:8000')
    }

    // 提取最后一条用户消息
    const userMessage = messages[messages.length - 1].content

    // 将历史消息格式化为一个提示
    let prompt = ''
    if (messages.length > 1) {
      // 简单地将历史消息合并成一个提示
      prompt = messages.slice(0, -1).map(msg =>
        `${msg.role === 'user' ? '用户' : 'AI'}: ${msg.content}`
      ).join('\n') + `\n用户: ${userMessage}`
    } else {
      prompt = userMessage
    }

    // 调用本地Ollama API
    console.log('使用真实API服务调用Ollama')
    const response = await generateResponse(prompt)

    // 返回AI回复
    return response.response
  } catch (error) {
    console.error('调用本地API出错:', error)

    // 增强错误日志
    let errorDetails = '未知错误'

    if (error.response) {
      console.error('错误状态码:', error.response.status)
      console.error('错误信息:', error.response.data)
      errorDetails = `服务器错误: ${error.response.status}`
    } else if (error.request) {
      console.error('请求已发出但未收到响应:', error.request)
      errorDetails = '服务器未响应，请确认Ollama服务已启动(http://localhost:8000)'
    } else {
      console.error('请求设置错误:', error.message)
      errorDetails = error.message
    }

    throw new Error(`与AI通信时出错: ${errorDetails}`)
  }
}

// 为了保持向后兼容，如果有代码直接调用其他API函数
export const chatWithAI = async (message, options = {}) => {
  try {
    const response = await generateResponse(message, options)
    return {
      content: response.response
    }
  } catch (error) {
    console.error('调用本地API出错:', error)
    throw error
  }
}
